import type { SavedSearchMetadata } from '@splunk/dashboard-types';
import type { SplunkSavedSearch } from '@splunk/splunk-utils/savedSearch';

export const extractMetadata = (
    entry?: Partial<SplunkSavedSearch>
): SavedSearchMetadata => {
    return {
        author: entry?.author,
        updated: entry?.updated,
        app: entry?.acl?.app,
        sharing: entry?.acl?.sharing,
        isScheduled: entry?.content?.is_scheduled,
        nextScheduledTime: entry?.content?.next_scheduled_time,
        savedSearchQuery: entry?.content?.search,
        earliestTime: entry?.content?.['dispatch.earliest_time'],
        latestTime: entry?.content?.['dispatch.latest_time'],
        alertType: entry?.content?.alert_type,
        alertTrack: entry?.content?.['alert.track'],
        actions: entry?.content?.actions,
    };
};
